const yup = require("yup");

// Payment email prefix validation (SendGrid-compatible)
// Allowed: a-z, 0-9, and these special chars: ! # $ % & ' * + - / = ? ^ _ ` { | } ~ .
// 1. Length: 3-64 chars
// 2. Only allowed chars
// 3. Cannot start or end with dot (.)
// 4. Cannot have two consecutive dots (..)
const paymentEmailRegex = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]{3,64}$/;

// Business card name validation (Stripe physical card second_line compatible)
// Allowed: A-Z, a-z, 0-9, space, and / - & \ ' : ( ) . @
const businessCardNameRegex = /^[A-Za-z0-9 /&':().@\\-]+$/;

const paymentEmailRules = yup
  .string()
  // Options go in the second argument: yup's matches takes (regex, options),
  // so a third argument is read by nothing and the rule keeps rejecting "".
  .matches(paymentEmailRegex, {
    message:
      "Invalid payment email prefix. Only a-z, 0-9, and ! # $ % & ' * + - / = ? ^ _ ` { | } ~ . are allowed, 3-64 chars.",
    excludeEmptyString: true,
  })
  .test(
    "no-leading-or-trailing-dot",
    "Payment email cannot start or end with a dot.",
    (val) => !val || (!/^\./.test(val) && !/\.$/.test(val)),
  )
  .test(
    "no-consecutive-dots",
    "Payment email cannot contain consecutive dots.",
    (val) => !val || !/\.\./.test(val),
  );

/**
 * `requirePaymentEmail` follows the payments entitlement. The profile tab hides
 * that field without it, and a required field nobody can see never passes, which
 * leaves Save disabled on every other field with nothing on screen to explain it.
 */
const buildCompanySettings = ({ requirePaymentEmail = true } = {}) =>
  yup.object().shape({
    businessLegalName: yup.string().required("Business Legal Name is required"),
    description: yup.string().required("Description is required"),
    businessDBA: yup.string().required("Doing Business As (DBA) is required"),
    businessCardName: yup
      .string()
      .required("Business Card Name is required")
      .matches(
        businessCardNameRegex,
        "Business Card Name may only contain letters, numbers, spaces, colons and / - & \\ ' ( ) . @",
      ),
    // No entitlement means no rendered field, so every rule on it is one the
    // reader can neither satisfy nor see. A legacy value that fails the prefix
    // rules would block Save exactly as the missing value did.
    paymentEmail: requirePaymentEmail
      ? paymentEmailRules.required("Payment Email is required")
      : yup.string(),
    businessEmail: yup.string(), // Not required
    phoneNumber: yup.string(), // Not required
    websiteURL: yup.string(), // Not required
  });

export { buildCompanySettings };
export default buildCompanySettings();
